import * as Icons from '@mui/icons-material'
import { IMenuItem } from '../../../../types'

export const menu: IMenuItem[] = [
  {
    link: '/',
    icon: Icons.Article,
  },
  // {
  //   link: '/messenger',
  //   icon: Icons.Forum,
  // },
  {
    link: '/friends',
    icon: Icons.Group,
  },
  // {
  //   link: '/groups',
  //   icon: Icons.Groups,
  // },
  // {
  //   link: '/photos',
  //   icon: Icons.Photo,
  // },
  // {
  //   link: '/music',
  //   icon: Icons.MusicNote,
  // },
]
